import { WebPlugin } from '@capacitor/core';
export class AppTrackingTransparencyWeb extends WebPlugin {
    async getStatus() {
        // Web platform doesn't have tracking transparency
        // Return 'authorized' as web doesn't require this permission
        return { status: 'authorized' };
    }
    async requestPermission() {
        // Web platform doesn't have tracking transparency
        // Return 'authorized' as web doesn't require this permission
        return { status: 'authorized' };
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map